import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ReportCard = ({ title, children, empty = false, detailUrl, highlight = false }) => {
    const { t } = useTranslation();
    return (
        <div style={{
            backgroundColor: highlight ? 'rgba(59, 130, 246, 0.1)' : 'rgba(30, 41, 59, 0.5)',
            borderRadius: '24px',
            padding: '1.5rem',
            border: highlight ? '1px solid rgba(59, 130, 246, 0.3)' : '1px solid rgba(255, 255, 255, 0.05)',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            boxShadow: highlight ? '0 8px 32px rgba(0, 0, 0, 0.3)' : 'none'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#f1f5f9' }}>{title}</h3>
                {detailUrl && !empty && (
                    <Link to={detailUrl} style={styles.detailBtn}>
                        {t('mypage.results.view_details')} &gt;
                    </Link>
                )}
            </div>
            {children}
        </div>
    );
};

const styles = {
    detailBtn: {
        fontSize: '0.8rem',
        color: '#60a5fa',
        textDecoration: 'none',
        padding: '0.4rem 0.8rem',
        borderRadius: '100px',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fontWeight: 'bold',
        transition: 'all 0.2s',
    }
};

export default ReportCard;
